
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Activity": [
      "CreatedCommentActivity",
      "CreatedHistoryActivity",
      "CreatedTopicActivity",
      "FillerActivity",
      "JoinedUserActivity",
      "PublishedPostActivity",
      "RepliedCommentActivity",
      "ThankedPostActivity"
    ],
    "MentionContent": [
      "MentionContentDelta",
      "MentionContentHighlights",
      "MentionContentSlack"
    ],
    "Notification": [
      "CommentNotification",
      "HistoryNotification",
      "InvitationNotification",
      "PostNotification",
      "ReactionNotification"
    ],
    "PostBacklink": [
      "Group",
      "Post",
      "Topic",
      "User"
    ],
    "PublicGroupFields": [
      "Group",
      "PublicGroup"
    ],
    "PublicPostFields": [
      "Post",
      "PublicPost"
    ],
    "PublicSearchResult": [
      "PublicPostSearchResult",
      "PublicTopicSearchResult"
    ],
    "PublicSeriesFields": [
      "PublicSeries",
      "Series"
    ],
    "PublicTopicFields": [
      "PublicTopic",
      "Topic"
    ],
    "PublicUserFields": [
      "PublicUser",
      "User"
    ],
    "RootPostFields": [
      "Post",
      "PublicPost",
      "SlimPost"
    ],
    "SearchResult": [
      "CommentSearchResult",
      "GroupSearchResult",
      "PostSearchResult",
      "TemplateSearchResult",
      "TopicSearchResult",
      "UserSearchResult"
    ],
    "SlimExternalPostFields": [
      "ExternalPost",
      "SlimExternalPost"
    ],
    "SlimPostFields": [
      "Post",
      "SlimPost"
    ],
    "SlimSeriesFields": [
      "PublicSeries",
      "Series",
      "SlimSeries"
    ],
    "SlimTopicFields": [
      "PublicTopic",
      "SlimTopic",
      "Topic"
    ]
  }
};
      export default result;
    